import React from 'react';
import { withRouter } from 'react-router-dom';

import { translate } from 'components/translate';
import { GROUPS, NAMES } from 'modules/app/services/datahub/constants';
import DatahubService from 'modules/app/services/datahub/DatahubService';
import { ACTIONS, CATEGORIES, EVENTS } from 'modules/app/services/ga/constants';
import plusAccess from 'modules/dashboard/assets/plus-access.svg';
import { PLUS_ACCESS_MAX_MEMBERS } from 'modules/dashboard/constants';
import { MembershipStore } from 'modules/membership';
import { TABS } from 'modules/salesManager/constants';
import PropTypes from 'prop-types';

import NavigationCard from './NavigationCard';

const PlusAccessNavigationCard = ({ t, history }) => {
  const registerMetrics = () => {
    const { marketplaceId } = MembershipStore;

    if (marketplaceId) {
      const DATAHUB_EVENT = {
        group: GROUPS.PLUS_ACCESS,
        name: NAMES.CARD_CONFIG_PLUS_ACCESS,
        user: { id: marketplaceId }
      };

      const GTM_EVENT = {
        event: EVENTS.INTERACTION,
        event_category: CATEGORIES.CLUB_ADMIN_CONTENT,
        event_action: ACTIONS.PLUS_ACCESS.CLICK_CONFIG_CARD,
        event_label: true
      };

      try {
        window.dataLayer.push(GTM_EVENT);
        DatahubService.sendMetrify(DATAHUB_EVENT);
      } catch (error) {
        // do nothing
      }
    }
  };

  const onClick = () => {
    registerMetrics();
    history.push('/sales', { tabIndex: TABS.PLUS_ACCESS });
  };

  return (
    <NavigationCard
      image={plusAccess}
      title={t('dashboard.navigation_card.plus_access.title')}
      description={t('dashboard.navigation_card.plus_access.description', {
        data: { amount: PLUS_ACCESS_MAX_MEMBERS }
      })}
      onClick={onClick}
      last
    />
  );
};

PlusAccessNavigationCard.propTypes = {
  t: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired
};

export default translate()(withRouter(PlusAccessNavigationCard));
